var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1247"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1247"
    },
    "bundlingPackage": "payments-ui-app",
    "bundlingPackageVersion": "static-1.28365",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};